<template>
    <div>
        <div class="status">
            <h2>{{ title }}</h2>
            <a v-if="isEditable" class="add add_expand" :class="{ open: addItemOpened }" @click.stop="addItemOpened = !addItemOpened" :title="$gettext('Přidat')" v-translate>Přidat</a>
        </div>

        <div class="filter expand_content" :class="{ open: addItemOpened}">
            <div class="field_left">
                <select-box
                    v-if="hasSelectableValues"
                    :id="'new_value_' + name"
                    :options="filteredSelectableOptions"
                    v-model="addedItem">
                    <translate>Přidat položku</translate>
                </select-box>
              <p v-else v-translate>Nejsou dostupné žádné položky pro přidání</p>
            </div>

            <div v-if="hasSelectableValues" class="field_right" >
                <p class="field">
                    <input class="btn" type="submit" @click.prevent.stop="addNewValue" :value="$gettext('Přidat')">
                </p>
            </div>
        </div>

        <table class="vypis vypis_detail">
            <tbody :class="['sortable_' + name, {sortable: isSortable, 'ui-sortable': isSortable}]">
                <tr :class="['sorted_' + name, {'ui-sortable-handle': isSortable}]" v-for="(value, index) in selectedOptionsData" :key="'line_' + name + '_' + index" :rowvalue="index">

                    <td class="no_padding drag_drop"><span/></td>
                    <td v-for="item in columns" :data-th="item.text" class="first_data">{{ value[item.value] }}</td>
                    <td class="no_padding edit">
                        <div class="edit_inner">
                            <a v-if="isDeletable(index)" class="btn btn_action btn_delete" :title="$gettext('Smazat')" @click.prvent.stop="removeValue(index)">{{ $gettext('Smazat') }}</a>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tr v-if="selectedIds.length === 0">
                <td colspan="8" v-translate>Žádné položky</td>
            </tr>
        </table>
    </div>
</template>

<script>

export default {
  name: "SortableTable",
  props: {
    isEditable: Boolean,
    title: String,
    allOptions: Array,
    value: Array,
    name: String,
    columns: Array,
    sortable: {
      type: Boolean,
      default: true,
    },
    deleteFunction: Function,
  },
  data(){
      return {
        addItemOpened: false,
        selectedIds: this.value,
        addedItem: null,
      }
  },
  mounted() {
    if (this.isSortable) {
      $('.sortable_' + this.name).sortable({
        stop: this.onSortingOrderChange
      });
    }
  },
  computed: {
    isSortable() {
      return this.isEditable && this.sortable;
    },
    filteredSelectableOptions(){
      if(this.allOptions.length) {
        let result = [];
        this.allOptions.filter(item => {
          if (!this.selectedIds.includes(item.id)){
            result.push({id: item.id, text: item.text});
          }
        })

        if(result.length > 0){
          this.addedItem = result[0].id;
        }

        return result;
      }else{
        return [];
      }
    },
    hasSelectableValues() {
      return this.filteredSelectableOptions.length > 0;
    },
    selectedOptionsData(){
      let result = {};
      this.allOptions.forEach(item => {
        if(this.selectedIds.includes(item.id)){
          result[item.id] = item;
        }
      })

      return result;
    }
  },
  methods: {
    isDeletable(value) {
      return this.isEditable && ((this.deleteFunction && this.deleteFunction(value)) || !this.deleteFunction);
    },
    addNewValue() {
      this.selectedIds.push(Number(this.addedItem));
      this.onChange(this.selectedIds);
    },
    removeValue(id){
      this.selectedIds.splice(this.selectedIds.indexOf(Number(id)), 1);
      this.onChange(this.selectedIds);
    },
    onSortingOrderChange() {
      let values = [];
      $('.sorted_' + this.name).each((el, x) => {
        values.push(Number($(x).attr('rowvalue')));
      });
      this.selectedIds = values;

      this.onChange(values);
    },
    onChange(values){
      this.$emit('input', values);
    }
  },
  watch:{
    value(){
      this.selectedIds = this.value;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SortableTable.vue